/* Designed and built by Aleksandra Szpunt (linkedin.com/in/alekszpunt), October 2026. */
/* TPC motion helpers. APPLIED 11 Oct 2026, her yes to all A to H. Goes with motion.css; only acts inside an element
   with class .mo (every page sets it on <html>).
   CSS does everything it can (buttons, tiles, menus, side basket, tap states). This file does the three things CSS
   cannot do on every browser yet: (D) open and close <details> with a smooth height, (C) slide the active tab fill,
   (E) tick the basket number and bump the menu badge when the count changes. No libraries, nothing on scroll,
   nothing runs on its own (E stays silent until the page has loaded and cart.js has restored the count, so only a
   real add bumps; html gets .mo-live then, which also gates the badge's CSS pop-in). Reduced motion: no height animation, the tab fill jumps, no tick or bump. */
(function(){
  'use strict';
  var RM = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
  var EASE = 'cubic-bezier(.22,1,.36,1)', OPEN = 300, EXIT = 220;
  function mo(el){ return el && el.closest && el.closest('.mo'); }

  /* ---- D. accordions: smooth height for every <details> inside .mo ---- */
  function closedHeight(d){
    var s = d.querySelector(':scope > summary'), cs = getComputedStyle(d);
    return s.offsetHeight + parseFloat(cs.borderTopWidth) + parseFloat(cs.borderBottomWidth) + parseFloat(cs.paddingTop) + parseFloat(cs.paddingBottom);
  }
  function body(d){ return [].filter.call(d.children, function(c){ return c.tagName !== 'SUMMARY'; }); }
  function run(d, from, to, ms, done){
    if (d._moAnim) d._moAnim.cancel();
    d.style.overflow = 'hidden';
    var a = d.animate([{ height: from + 'px' }, { height: to + 'px' }], { duration: ms, easing: EASE });
    d._moAnim = a;
    function end(){ d.style.overflow = ''; d._moAnim = null; if (done) done(); }
    a.onfinish = end; a.oncancel = end;
  }
  function shut(d){
    var from = d.offsetHeight, to = closedHeight(d), name = d.getAttribute('name');
    if (name) d.removeAttribute('name');          // keep it open while it closes, then put the group back
    d._moClosing = true;
    d.classList.add('mo-closing');                // the minus turns back into a plus as the close starts (motion.css)
    run(d, from, to, EXIT, function(){ if (d._moClosing) d.open = false; d._moClosing = false; d.classList.remove('mo-closing'); if (name) d.setAttribute('name', name); });
  }
  function show(d){
    d.classList.remove('mo-closing');
    var name = d.getAttribute('name');
    if (name) [].forEach.call(document.querySelectorAll('details[name="' + name + '"][open]'), function(o){ if (o !== d) shut(o); });
    if (name) d.removeAttribute('name');
    var from = d.offsetHeight; d.open = true; var to = d.offsetHeight;
    if (name) d.setAttribute('name', name);
    run(d, from, to, OPEN);
    body(d).forEach(function(c){ c.animate([{ opacity: 0 }, { opacity: 1 }], { duration: OPEN, delay: 40, easing: EASE, fill: 'backwards' }); });
  }
  document.addEventListener('click', function(e){
    var s = e.target.closest && e.target.closest('summary');
    if (!s || !mo(s) || RM.matches) return;
    var d = s.parentElement; if (!d || d.tagName !== 'DETAILS') return;
    if (e.target.closest('a,button,input,select,textarea') && e.target.closest('a,button,input,select,textarea') !== s) return;
    e.preventDefault();
    var closing = d._moClosing;
    if (d._moAnim) { d._moClosing = false; d._moAnim.cancel(); }
    if (d.open && !closing) shut(d); else show(d);
  });

  /* ---- C. tabs: one fill that slides to the active tab ---- */
  var TAB = '.ing-tab,.sp-plan,.tab';
  function isOn(b){ return b.getAttribute('aria-pressed') === 'true' || b.getAttribute('aria-selected') === 'true'; }
  function place(list){
    var tabs = [].slice.call(list.querySelectorAll(TAB)).filter(function(b){ return b.parentElement === list; });
    var on = tabs.filter(isOn)[0], ind = list.querySelector(':scope > .mo-ind');
    tabs.forEach(function(b){ b.classList.toggle('is-mo-on', b === on); });
    if (!on) { ind.style.opacity = '0'; return; }
    ind.style.opacity = '';
    list.style.setProperty('--mo-x', on.offsetLeft + 'px');
    list.style.setProperty('--mo-y', on.offsetTop + 'px');
    list.style.setProperty('--mo-w', on.offsetWidth + 'px');
    list.style.setProperty('--mo-h', on.offsetHeight + 'px');
  }
  function setupTabs(list){
    if (list._moTabs || !mo(list)) return;
    var tabs = [].slice.call(list.querySelectorAll(TAB)).filter(function(b){ return b.parentElement === list; });
    if (tabs.length < 2) return;
    list._moTabs = true;
    var on = tabs.filter(isOn)[0] || tabs[0], cs = getComputedStyle(on);
    list.style.setProperty('--mo-c', cs.backgroundColor);           // the fill takes the active tab's own colour
    list.style.setProperty('--mo-r', cs.borderTopLeftRadius);
    tabs.forEach(function(b){                                       // labels sit above the fill
      if (b.querySelector(':scope > .mo-lab')) return;
      var s = document.createElement('span'); s.className = 'mo-lab';
      while (b.firstChild) s.appendChild(b.firstChild);
      b.appendChild(s);
    });
    var ind = document.createElement('span'); ind.className = 'mo-ind'; ind.setAttribute('aria-hidden', 'true');
    list.insertBefore(ind, list.firstChild);
    list.classList.add('mo-tabs');
    place(list);
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ list.classList.add('mo-ready'); }); });
    new MutationObserver(function(){ place(list); }).observe(list, { attributes: true, subtree: true, attributeFilter: ['aria-pressed', 'aria-selected'] });
    if (window.ResizeObserver) new ResizeObserver(function(){ place(list); }).observe(list);
    // the panel that a tab reveals fades in (opacity only)
    var host = list.parentElement;
    new MutationObserver(function(ms){
      if (RM.matches) return;
      ms.forEach(function(m){ var el = m.target; if (m.attributeName === 'hidden' && !el.hidden && el.matches('.ing-panel,.pp-tab-panel,.pp-sys-panel,[role=tabpanel]')) { el.classList.remove('mo-panel-in'); void el.offsetWidth; el.classList.add('mo-panel-in'); } });
    }).observe(host, { attributes: true, subtree: true, attributeFilter: ['hidden'] });
  }
  function initTabs(root){
    [].forEach.call((root || document).querySelectorAll('.mo .ing-tabs,.mo .sp-plans,.mo .tabs,.mo .pp-sys-tabs,.mo [role=tablist]'), function(l){
      if (l.closest('[class*="pt-"]') || l.matches('[class*="pt-"]')) return;   // Postie keeps its own tabs
      setupTabs(l);
    });
  }

  /* ---- E. basket: the stepper number ticks, the menu badge bumps ---- */
  // live only after the page has loaded and cart.js has restored the count (it sets the badge on DOMContentLoaded):
  // a page that opens with items in the basket stays still; only a real add or change ticks and bumps
  var live = false;
  function goLive(){ requestAnimationFrame(function(){ requestAnimationFrame(function(){ live = true; document.documentElement.classList.add('mo-live'); }); }); }
  if (document.readyState === 'complete') goLive(); else window.addEventListener('load', goLive);
  function replay(el, cls){ el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }
  new MutationObserver(function(ms){
    if (RM.matches || !live) return;
    ms.forEach(function(m){
      var t = m.target.nodeType === 1 ? m.target : m.target.parentElement; if (!t || !mo(t)) return;
      if (t.matches('.sp-badge')) replay(t, 'mo-bump');
      else if (t.matches('.sp-n')) replay(t, 'mo-tick');
    });
  }).observe(document.documentElement, { childList: true, characterData: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ initTabs(); });
  else initTabs();
  window.TPCMotion = { initTabs: initTabs };
})();
